import { Pageable } from './pageable';
import { Sorteable } from './sorteable';

/**
 * An array of data with an associated page object used for paging
 */
export class PagedData<T> {
    content: T[] = [];
    pageable: Pageable = new Pageable();
    last: boolean = false;
    totalElements: number = 0;
    totalPages: number = 0;
    number: number = 0;
    sort: Sorteable = new Sorteable();
    first: boolean = true;
    numberOfElements: number = 0;
    size: number = 10;
    empty: boolean = true;
}
